import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Iconify from 'src/components/iconify';
import { useJobCreationContext } from 'src/sections/job2/hooks/use-job-creation-context';
import Editor from './editor';
import Preview from './preview';
import { useAuthContext } from 'src/auth/hooks';

export default function PostOnLinkedin() {
  // context
  const { organization } = useAuthContext();

  const { jobApplyLink, jobTitle, jobExperience } = useJobCreationContext();

  // states
  const [isExpanded, setIsExpanded] = useState(true);
  const [postContent, setPostContent] = useState(
    `Hello Everyone,\n${organization?.name} is actively seeking enthusiastic individuals with ${jobExperience} years of experience in ${jobTitle}.\n\nWe're a closely knit team who love to play off each others energy. At ${organization?.name} we focus on helping our employees enhance their individual skills and progress forwards in their career.\n\nApply through the link below: \n${jobApplyLink}?utm_source=linkedin\n\n#hiring #jobopportunity #applynow`,
  );

  // functions
  const handleShareOnLinkedin = async () => {
    const url = encodeURIComponent(`${jobApplyLink}?utm_source=linkedin`);

    const text = encodeURIComponent(postContent);

    const link = `https://www.linkedin.com/feed/?shareActive=true&shareUrl=${url}&text=${text}`;

    window.open(link, '_blank');
  };

  // effects
  useEffect(() => {
    if (
      jobApplyLink &&
      jobTitle &&
      jobExperience !== null &&
      organization?.name
    )
      setPostContent(
        `Hello Everyone,\n${organization?.name} is actively seeking enthusiastic individuals with ${jobExperience} years of experience in ${jobTitle}.\n\nWe're a closely knit team who love to play off each others energy. At ${organization?.name} we focus on helping our employees enhance their individual skills and progress forwards in their career.\n\nApply through the link below: \n${jobApplyLink}?utm_source=linkedin\n\n#hiring #jobopportunity #applynow`,
      );
  }, [jobApplyLink, jobTitle, jobExperience, organization?.name]);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={() => {
        setIsExpanded(prevProps => !prevProps);
      }}
    >
      <AccordionSummary expandIcon={<Iconify icon="tabler:chevron-down" />}>
        <Stack spacing="8px">
          <Typography variant="subheading1" fontWeight={700}>
            Post on Linkedin
          </Typography>
          <Typography variant="input" color="content.primaryBlack3">
            Share a pre-made LinkedIn post in minutes.
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="row" spacing="24px" height="500px">
          <Editor value={postContent} setValue={setPostContent} />
          <Preview
            postContent={postContent}
            handleShareOnLinkedin={handleShareOnLinkedin}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
